import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { AlertService } from "../../../../shared/alert.service";
import { UserResponse } from "../../../../../../../model";
import { QueryParam } from "../../../../shared/query-param";
import { HttpService } from '../../../../shared/http.service';
import {ActivatedRoute} from "@angular/router";


@Component({
  selector: 'app-selected-user-list',
  templateUrl: './selected-user-list.component.html',
  styleUrls: ['./selected-user-list.component.scss', '../../book-send.component.scss']
})
export class SelectedUserListComponent implements OnInit {

  // Search
  searchResultItems: Observable<UserResponse.User[]>;
  private searchTerms = new Subject<string>();
  private searching = false;

  montevideoUsers = [];
  outOfMontevideoUsers = [];
  undefinedUsers = [];
  selectedUsers = [];
  idsSelectedUsers = [];
  onValidationError = false;
  target = '';
  rol = '';


  constructor(
    private alertService: AlertService,
    private httpService: HttpService,
    private route: ActivatedRoute,
  ){}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loadSettings(params['target']);
      this.getAllUsersByDepartment();
      this.searchResultItems = this.searchTerms
        .debounceTime(300)        // wait 300ms after each keystroke before considering the term
        .distinctUntilChanged()   // ignore if next search term is same as previous
        .do(() => this.searching = true)
        .switchMap(term => term ? this.searchItem(term) : Observable.of<UserResponse.User[]>([]))
        .catch(error => {
          this.alertService.error(error);
          return Observable.of<UserResponse.User[]>([]);
        })
        .do(() => this.searching = false);
    });
  }

  // SEARCH
  search(term: string): void {
    this.onValidationError = false;
    this.searchTerms.next(term);
  }

  private searchItem(query: string): Observable<UserResponse.User[]> {
    if (query !== '') {
      const params = new Array<QueryParam>();
      params[0] = new QueryParam('pagination', '20');
      params[1] = new QueryParam('offset', '0');
      params.push(new QueryParam('active', '1'));
      params.push(new QueryParam('role', this.rol));
      params.push(new QueryParam('query', query));
      const resultObservable: Observable<UserResponse.All> = this.httpService.getWithParams('/User/All', params, UserResponse.All);

      return resultObservable
        .map(itemResponse => {
            return itemResponse.objects.filter(element => {
              if (this.idsSelectedUsers.indexOf(element.id) === -1) {
                return element;
              }
            });
          },
          error => {
            return [];
          }
        );
    }
  }

  loadSettings(target) {
    if (target !== this.target) {
      this.montevideoUsers = [];
      this.outOfMontevideoUsers = [];
      this.undefinedUsers = [];
      this.selectedUsers = [];
      this.idsSelectedUsers = [];
      switch (target) {
        case 'consignee':
          this.target = 'consignatarios';
          this.rol = '3';
          break;
        case 'school':
          this.target = 'escuelas';
          this.rol = '4';
          break;
        case 'customers':
          this.target = 'clientes';
          this.rol = '2';
          break;
      }
    }
  }

  cleanSearch() {
    this.searchTerms.next('');
  }

  cleanList() {
    this.selectedUsers = [];
    this.idsSelectedUsers = [];
  }

  delete(value) {
    const userIndex = this.selectedUsers.indexOf(value);
    const idIndex = this.idsSelectedUsers.indexOf(value.id);
    if (userIndex !== -1) {
      this.selectedUsers.splice(userIndex, 1);
      this.idsSelectedUsers.splice(idIndex, 1);
    }
  }

  addUsersGroup(value) {
    let toAddList;
    switch(value) {
      case 0:
        toAddList = this.montevideoUsers.slice().concat(this.outOfMontevideoUsers.slice().concat(this.undefinedUsers.slice()));
        break;
      case 1:
        toAddList = this.montevideoUsers.slice();
        break;
      case 2:
        toAddList = this.outOfMontevideoUsers.slice();
        break;
      default:
        return;
    }
    this.selectedUsers = [];
    this.idsSelectedUsers = [];
    toAddList.map(item => {
      if (this.idsSelectedUsers.indexOf(item.id) === -1) {
        this.idsSelectedUsers.push(item.id);
        this.selectedUsers.push(item);
      }
    });
  }

  addItem(value) {
    this.selectedUsers.push(value);
    this.idsSelectedUsers.push(value.id);
  }

  getAllUsersByDepartment() {
    const params = new Array<QueryParam>();
    params[0] = new QueryParam('offset', '0');
    params.push(new QueryParam('active', '1'));
    params.push(new QueryParam('role', this.rol));
    this.httpService.getWithParams('/User/All', params, UserResponse.All)
      .subscribe( response => {
        params.push(new QueryParam('pagination', response.length.toString()));
        this.httpService.getWithParams('/User/All', params, UserResponse.All)
          .subscribe(
            userResponse => {
              userResponse.objects.map(user =>{
                if (user.departament) {
                  if (user.departament.toUpperCase() === 'MONTEVIDEO') {
                    this.montevideoUsers.push(user);
                  } else if (user.departament !== '-'){
                    this.outOfMontevideoUsers.push(user);
                  } else {
                    this.undefinedUsers.push(user);
                  }
                } else {
                  this.undefinedUsers.push(user);
                }
              });
            },
            error => {
              console.log('error', error);
            }
          );
      },
  error => {
          console.log('error', error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/book/book-send/first-step/selected-user-list/selected-user-list.component.ts